import type {
  AnimationProperties,
  AnimationsKit,
  EffectRangeAll,
  TwoDirection,
} from '../../../types';
import { getCssUnits } from '../../../utils/animationsUtils';

const name = 'PanScroll';
const properties: AnimationProperties = {
  schema: {},
};

const directions = {
  left: 1,
  right: -1,
};

const ease = 'linear';

const rangeValues = {
  in: (startX: number | string, _endX: number | string) => ({
    fromValue: startX,
    toValue: 0,
  }),
  out: (startX: number | string, _endX: number | string) => ({
    fromValue: 0,
    toValue: startX,
  }),
  continuous: (startX: number | string, endX: number | string) => ({
    fromValue: startX,
    toValue: endX,
  }),
};

/**
 * Pan Scroll
 */
function animate(
  kit: AnimationsKit,
  elements: HTMLElement[],
  _duration: number,
  _delay: number,
  {
    distance = { value: 400, type: 'px' },
    direction = 'left',
    startFromOffScreen = true,
    range = 'in',
    ...params
  }: {
    distance?: { value: number; type: string };
    direction?: TwoDirection;
    startFromOffScreen?: boolean;
    range?: EffectRangeAll;
  } = {},
) {
  const sequence = kit.sequence(params);
  elements.forEach((element) => {
    const { left, width } = element.getBoundingClientRect();
    const { innerWidth } = kit.frame;
    const positions = {
      left: {
        startX: -left - width,
        endX: innerWidth - left,
      },
      right: {
        startX: innerWidth - left,
        endX: -left - width,
      },
    };
    const travel = distance.value * directions[direction];
    const { startX, endX } = startFromOffScreen
      ? positions[direction]
      : {
          startX: `${-travel}${getCssUnits(distance.type)}`,
          endX: `${travel}${getCssUnits(distance.type)}`,
        };

    const { fromValue, toValue } = rangeValues[range](startX, endX);
    sequence.add(
      kit.animate('BasePosition', elements, 1000, 0, {
        from: { x: fromValue },
        to: { x: toValue },
        ease,
      }),
    );
  });

  return sequence.get();
}
export { name, properties, animate };
